import { type FormulaFunctionInfo } from '@blaze-shared/api-contracts-domain';

export const FORMULAS_STATE_KEY = 'formulas';

export interface FormulasState {
  formulaFunctions: FormulaFunctionInfo[];
}
